export const tagManagerArgs = {
  gtmId: "GTM-PPZWHLS",
  dataLayerName: "PageDataLayer"
};
